<div class="text-center lh-20px text-xxs sm:lh-30px sm:h5-responsive sm:font-bold 2xl:text-[20px]">
  <div class="grid grid-cols-[1fr_30px] gap-1">
    <div class="rate-note-limit-container">
      <!-- rate -->
      <div class="flex justify-center gap-2">
        <span>
          @if(rate()[trade()].onCall) { <app-call-for-rate [phoneNumber]="monisferOfficeTel"></app-call-for-rate> } @else {
          {{ rate()[trade()].value | currencyRate : rate().precision }}
          }
        </span>
      </div>

      <!-- note and limits -->
      <div>
        <!-- note -->
        @if(rate()[trade()].note) {
        <ng-container *ngIf="rate()[trade()].note?.type == 'TEXT'; else NoteIcon">
          <p class="whitespace-nowrap">{{ rate()[trade()].note?.value }}</p>
        </ng-container>
        <ng-template #NoteIcon>
          <p class="h-8">
            <mat-icon>{{ rate()[trade()].note?.value }}</mat-icon>
          </p>
        </ng-template>
        }

        <!-- limit -->
        @if(rate()[trade()].limit) {
        <ng-container *ngIf="rate()[trade()].limit?.type == 'TEXT'; else LimitIcon">
          @if(rate()[trade()].stopped) {
          <p class="whitespace-nowrap h-8">{{ rate()[trade()].limit?.value }}</p>
          } @else {
          <p class="whitespace-nowrap flex items-center justify-center !h-8"><mat-icon>check</mat-icon>({{ rate()[trade()].limit?.value }})</p>
          }
        </ng-container>
        <ng-template #LimitIcon>
          <p class="h-8">
            <mat-icon>{{ rate()[trade()].limit?.value }}</mat-icon>
          </p>
        </ng-template>
        }
      </div>
    </div>

    <!-- alert btn -->
    <ng-content></ng-content>
  </div>
</div>
